export default __webpack_public_path__ + "static/media/tutorial4-5.d99814e2.png";